import React from 'react';
import "./aboutpage.css";
// Adjust the path below depending on where your asset lives in your src folder
import aboutImg from '../../assets/wepb_images/about.png';
import yellowbg from "../../assets/yellow-bg.png";

function Aboutpage() {
  return (
    <section className="about-section" id="aboutsection">
      <div className="about-container">

        {/* Left Side: Single Composite Image */}
        <div className="about-image-side">
          <img src={aboutImg} alt="Fazo Academy training and collaboration" className="composite-img" />
        </div>

        {/* Right Side: Content */}
        <div className="about-content-side">
          <span className="sub-heading1">FAZO ACADEMY</span>
          <br />
          <img
            src={yellowbg}
            alt="brush stroke"
            className="title-line"
          />
          <h4 className="main-title">A digital future beckons</h4>

          <div className="text-content">
            <p>
              It's a fast-evolving contemporary enterprise environment increasingly
              dependent on information technology as a key growth driver. Fazo
              Academy is a new age training ecosystem that enables aspiring IT
              professionals to gather career critical skill sets and land dream jobs in the
              software sector.
            </p>
            <p>
              Headquartered in Chennai, Fazo which started off as a payroll
              management entity in 2015 has now successfully transitioned into a
              reputed software training academy. Plans are afoot to start centres in
              Bangalore shortly. The institute offers a wide variety of core IT courses
              including AI, ML, DL, Python, .Net, Java and many more. Experienced
              faculty, robust infrastructure, astute management and rich cumulative
              experience help Fazo give a definitive head start to potential IT
              professionals.
            </p>
          </div>

          <div className="why-choose-us">
            <h3>WHY FAZO ACADEMY?</h3>
            <ul className="features-list">
              <li><span className="checkmark">✓</span> Live projects</li>
              <li><span className="checkmark">✓</span> Robust infrastructure</li>
              <li><span className="checkmark">✓</span> Wide range of courses</li>
              <li><span className="checkmark">✓</span> Seasoned faculty</li>
              <li><span className="checkmark">✓</span> Placement assistance</li>
              <li><span className="checkmark">✓</span> Power packed curriculum</li>
              <li><span className="checkmark">✓</span> Emphasis on soft skills development</li>
              <li><span className="checkmark">✓</span> Proven training methodologies</li>
              <li><span className="checkmark">✓</span> Convenient timings</li>
              <li><span className="checkmark">✓</span> Affordable fees</li>




            </ul>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Aboutpage;